import Config from 'config';

export const isBreakdownTypeAvailable = reportTitle => ['Payout settlement Report'].includes(reportTitle);

export function buildReportUrl(userId, reportType, fileFormat, timeRange, currency, breakdownType, includeExtendedAuditReport) {
  const commonQueryParams = `&extended=${includeExtendedAuditReport}`;
  const gilaQueryParams = `&gila${commonQueryParams}`;
  const currencyParams = currency ? `&currency=${currency}` : '';
  const breakdownTypeParams = breakdownType ? `&breakdownType=${breakdownType}` : '';

  // reportType is the report type
  switch (reportType) {
    case 'cost_items':
      if (fileFormat.toLowerCase() == 'csv') {
        return `${Config.api.host}/user_reports/${userId}/${reportType}.${fileFormat}${timeRange}${commonQueryParams}`;
      }
  }
  return `${Config.api.host}/user_reports/${userId}/${reportType}.${fileFormat}${timeRange}${currencyParams}${breakdownTypeParams}${gilaQueryParams}`;
}



// WEBPACK FOOTER //
// ./src/lib/report-utils.js